export enum MODULES {
  IDENTITIES = 'IDENTITIES',
  APPS = 'APPS',
  CONNECTIONS = 'CONNECTIONS',
  DOCUMENTS = 'DOCUMENTS',
  MODULES = 'MODULES',
  NOTICES = 'NOTICES',
  KNOWLEDGEBASE = 'KNOWLEDGEBASE',
  NOTIFICATIONS = 'NOTIFICATIONS',
  MESSAGES = 'MESSAGES',
  LOGS = 'LOGS',
  WORKFLOWS = 'WORKFLOWS',
  MAILBOX = 'MAILBOX',
  AUTHORIZATION_PERMISSIONS = 'AUTHORIZATION_PERMISSIONS',
  AUTHORIZATION_ROLES = 'AUTHORIZATION_ROLES',
  AUTHORIZATION_PRIVILEGES = 'AUTHORIZATION_PRIVILEGES',
  STORAGE_DRIVE = 'STORAGE_DRIVE',
  STORAGE_RECYCLE_BIN = 'STORAGE_TRASH',
  REFERENCES = 'REFERENCES',
  INTEGRATIONS = 'INTEGRATIONS',
  VIRTUAL_MODULES = 'VIRTUAL_MODULES',

  SETUP = 'SETUP',
  SAAS_TENANT = 'SAAS_TENANT',
  SAAS_USERS = 'SAAS_USERS',
  SAAS_SUBSCRIPTIONS = 'SAAS_SUBSCRIPTIONS',
  SAAS_INVOICES = 'SAAS_INVOICES',
  SAAS_SETTINGS = 'SAAS_SETTINGS',
  SAAS_PAYMENTS = 'SAAS_PAYMENTS',

  /** BMS **/
  ADDITIONAL_STORAGE = 'ADDITIONAL_STORAGE',
  INVOICES = 'INVOICES',
  RECEIPTS = 'RECEIPTS',
  EXTERNAL_USERS = 'EXTERNAL_USERS',
  COMMISSION_CODES = 'COMMISSION_CODES',
  AGENT_COMMISSION_CODES = 'AGENT_COMMISSION_CODES',
  // CREDIT_NOTES = 'CREDIT_NOTES',
  // DEBIT_NOTES = 'DEBIT NOTES',
  CREDIT_DEBIT_NOTES = 'CREDIT_DEBIT_NOTES',
  CUSTOMERS = 'CUSTOMERS',
  CLAIMS = 'CLAIMS',
  REPORTS = 'REPORTS',
  USERS = 'USERS',
  COMMISSIONS = 'COMMISSIONS',
  RECONCILIATIONS = 'RECONCILIATIONS',
  BROKERS = 'BROKERS',
  COVER_NOTES = 'COVER_NOTES',
  LEADS = 'LEADS',
  POLICIES = 'POLICIES',
  INSURERS = 'INSURERS',
  PRODUCTS = 'PRODUCTS',
  ENDORSEMENT = 'ENDORSEMENT',
  TICKETS = 'TICKETS',
  SUBSCRIBERS = 'SUBSCRIBERS',
  SUBSCRIPTIONS = 'SUBSCRIPTIONS',
  BILLING = 'BILLING',
}

export enum MODULE_GROUPS {
  AUTHORIZATION = 'AUTHORIZATION',
  INTEGRATIONS = 'INTEGRATIONS',
  VIRTUAL_MODULES = 'VIRTUAL_MODULES',
  STORAGE = 'STORAGE',
  REFERENCES = 'REFERENCES',
  LEADS = 'LEADS',
  POLICIES = 'POLICIES',
  INSURERS = 'INSURERS',
  PRODUCTS = 'PRODUCTS',
  ENDORSEMENT = 'ENDORSEMENT',
  ADDITIONAL_STORAGE = 'ADDITIONAL_STORAGE',
  COVER_NOTES = 'COVER_NOTES',
  INVOICES = 'INVOICES',
  RECEIPTS = 'RECEIPTS',
  EXTERNAL_USERS = 'EXTERNAL_USERS',
  COMMISSION_CODES = 'COMMISSION_CODES',
  CREDIT_NOTES = 'CREDIT_NOTES',
  DEBIT_NOTES = 'DEBIT NOTES',
  CUSTOMERS = 'CUSTOMERS',
  CLAIMS = 'CLAIMS',
  REPORTS = 'REPORTS',
  USERS = 'USERS',
  COMMISSIONS = 'COMMISSIONS',
  RECONCILIATIONS = 'RECONCILIATIONS',
  BROKERS = 'BROKERS',
}

export enum MODULE_STATUSES {
  ACTIVATE = 'activate',
  DEACTIVATE = 'deactivate',
  HIDDEN = 'hidden',
  DISABLE = 'disable',
}
